import {
  ButtonGroup,
  ButtonGroupItem,
  Tooltip,
} from "@light-technology/components";

import type {
  PlaybookContentIntegrationType,
  PlaybookContentPlanType,
} from "../../state/api.types";
import { INTEGRATIONS, PLAN_TYPES } from "./constants";
import { usePlaybookFilters } from "./hooks";

const ALL_PLAN_KEY = "all";

const PLAN_TYPE_OPTIONS = Object.entries(PLAN_TYPES).map(([key, config]) => {
  const value = key as PlaybookContentPlanType;
  return { ...config, value };
});

const INTEGRATION_TYPE_OPTIONS = Object.entries(INTEGRATIONS).map(
  ([key, config]) => {
    const value = key as PlaybookContentIntegrationType;
    return { ...config, value };
  },
);

export const PlaybookFilters = () => {
  const { planFilter, integrationFilter, setPlanType, setIntegrationType } =
    usePlaybookFilters();

  return (
    <div className="flex flex-col gap-8">
      <div className="flex flex-col gap-md">
        <p className="text-sm text-tertiary">Filter guides by plan type</p>
        <ButtonGroup
          size="sm"
          selectedKeys={[planFilter ?? ALL_PLAN_KEY]}
          onSelectionChange={(keys) => {
            const key = [...keys][0] as
              PlaybookContentPlanType | typeof ALL_PLAN_KEY | undefined;
            if (!key || key === ALL_PLAN_KEY) {
              setPlanType(null);
            } else {
              setPlanType(key);
            }
          }}
          disallowEmptySelection
        >
          <ButtonGroupItem key={ALL_PLAN_KEY} id={ALL_PLAN_KEY}>
            All
          </ButtonGroupItem>
          {PLAN_TYPE_OPTIONS.map(({ value, tooltip, icon: Icon }) => (
            <Tooltip key={value} title={tooltip} isDisabled={!tooltip} arrow>
              <ButtonGroupItem id={value} iconLeading={Icon} />
            </Tooltip>
          ))}
        </ButtonGroup>
      </div>

      <div className="flex flex-col gap-md">
        <p className="text-sm text-tertiary">Filter guides by integration</p>
        <ButtonGroup
          size="sm"
          selectedKeys={[integrationFilter]}
          onSelectionChange={(keys) => {
            const key = [...keys][0] as
              PlaybookContentIntegrationType | undefined;
            if (key) {
              setIntegrationType(key);
            }
          }}
          disallowEmptySelection
        >
          {INTEGRATION_TYPE_OPTIONS.map(({ value, label, tooltip }) => (
            <Tooltip key={value} title={tooltip} isDisabled={!tooltip} arrow>
              <ButtonGroupItem id={value}>{label}</ButtonGroupItem>
            </Tooltip>
          ))}
        </ButtonGroup>
      </div>
    </div>
  );
};
